export default {
  path: '/hotel-management',
  component: () => import('@/views/hotel-management/Index'),
  redirect: { name: 'hotel-management-transactions' },
  children: [
    {
      path: 'availability-subscriptions',
      name: 'hotel-management-availability-subscriptions',
      component: () => import('@/views/hotel-management/availability-subscriptions/Index.vue'),
      meta: {
        title: 'My availability subscriptions',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor'],
      }
    },
    {
      path: 'calendar',
      name: 'hotel-management-calendar',
      component: () => import('@/views/hotel-management/calendar/Index.vue'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'hotel_reception', 'hotel_reservations', 'reservations_supervisor'],
        compactMain: 'true'
      }
    },
    {
      path: 'reservations',
      component: () => import('@/views/hotel-management/reservations/Index.vue'),
      children: [
        {
          path: '',
          component: () => import('@/views/hotel-management/reservations/list/Layout.vue'),
          children: [
            {
              path: '',
              name: 'hotel-management-reservations-list-upcoming',
              component: () => import('@/views/hotel-management/reservations/list/Upcoming.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'hotel_reservations'],
              }
            },
            {
              path: 'inhouse',
              name: 'hotel-management-reservations-list-inhouse',
              component: () => import('@/views/hotel-management/reservations/list/InHouse.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'hotel_reservations'],
              }
            },
            {
              path: 'archive',
              name: 'hotel-management-reservations-list-archive',
              component: () => import('@/views/hotel-management/reservations/list/Archive.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'hotel_reservations'],
              }
            },
            {
              path: 'cancelled',
              name: 'hotel-management-reservations-list-cancelled',
              component: () => import('@/views/hotel-management/reservations/list/Cancelled.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'hotel_reservations'],
              }
            },
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/hotel-management/reservations/detail/Layout.vue'),
          children: [
            {
              path: '',
              name: 'hotel-management-reservations-detail-reservation',
              component: () => import('@/views/hotel-management/reservations/detail/Reservation.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'hotel_reception', 'hotel_reservations', 'reservations_supervisor'],
              }
            },
            {
              path: 'rooms',
              name: 'hotel-management-reservations-detail-rooms',
              component: () => import('@/views/hotel-management/reservations/detail/rooms/Layout.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'hotel_reception', 'hotel_reservations', 'reservations_supervisor'],
              },
              children: [
                {
                  path: ':roomId?',
                  name: 'hotel-management-reservations-detail-rooms-detail',
                  component: () => import('@/views/hotel-management/reservations/detail/rooms/Folio.vue'),
                  meta: {
                    title: 'Hotel management',
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'hotel_reception', 'hotel_reservations', 'reservations_supervisor'],
                  },
                },
              ]
            },
            {
              path: 'invoice',
              name: 'hotel-management-reservations-detail-invoice',
              component: () => import('@/views/hotel-management/reservations/detail/Invoice.vue'),
              meta: {
                title: 'Hotel management',
                roles: ['general_manager'],
              }
            },
          ]
        },
      ]
    },
    {
      path: 'house-accounts',
      component: () => import('@/views/hotel-management/house-accounts/Index'),
      children: [
        {
          path: '',
          name: 'hotel-management-house-accounts',
          component: () => import('@/views/hotel-management/house-accounts/List'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager', 'hotel_reception'],
          }
        },
        {
          path: ':id',
          name: 'hotel-management-house-accounts-detail',
          component: () => import('@/views/hotel-management/house-accounts/Detail'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager', 'hotel_reception'],
          }
        },
      ]
    },
    {
      path: 'restaurant-receipts',
      component: () => import('@/views/hotel-management/restaurant-receipts/Layout'),
      children: [
        {
          path: '',
          name: 'hotel-management-restaurant-receipts-guests',
          component: () => import('@/views/hotel-management/restaurant-receipts/Guests'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager', 'hotel_reception'],
          }
        },
        {
          path: 'management',
          name: 'hotel-management-restaurant-receipts-management',
          component: () => import('@/views/hotel-management/restaurant-receipts/Management'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager'],
          }
        },
      ]
    },
    {
      path: 'dashboard',
      name: 'hotel-management-dashboard',
      component: () => import('@/views/hotel-management/Dashboard'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception'],
      }
    },
    {
      path: 'massage',
      name: 'hotel-management-massage',
      component: () => import('@/views/hotel-management/Massage'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception', 'therapist']
      }
    },
    {
      path: 'balance',
      name: 'hotel-management-balance',
      component: () => import('@/views/hotel-management/Balance'),
      meta: {
        title: 'Hotel management',
        roles: ['hotel_reception']
      }
    },
    {
      path: 'shop-stocktaking',
      name: 'hotel-management-shop-stocktaking',
      component: () => import('@/views/hotel-management/shop-stocktaking/ShopStocktaking'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception']
      }
    },
    {
      path: 'shop-stocktaking/:id',
      name: 'hotel-management-shop-stocktaking-detail',
      component: () => import('@/views/hotel-management/shop-stocktaking/Detail'),
      meta: {
        title: 'Hotel management',
        roles: ['general_manager', 'hotel_reception']
      }
    },
    {
      path: 'balance-history',
      component: () => import('@/views/hotel-management/balance-history/Index'),
      children: [
        {
          path: '',
          name: 'hotel-management-balance-history',
          component: () => import('@/views/hotel-management/balance-history/List'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          name: 'hotel-management-balance-history-detail',
          component: () => import('@/views/hotel-management/balance-history/Detail'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        }
      ]
    },
    {
      path: 'transactions',
      component: () => import('@/views/hotel-management/transactions/Layout'),
      children: [
        {
          path: '',
          name: 'hotel-management-transactions',
          component: () => import('@/views/hotel-management/transactions/Transactions'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        },
        {
          path: 'pos',
          name: 'hotel-management-transactions-pos',
          component: () => import('@/views/hotel-management/transactions/POS'),
          meta: {
            title: 'Hotel management',
            roles: ['general_manager']
          }
        }
      ]
    },
  ]
}
